const permissions = {

 admin: {
    dashboard: true,
    clients: true,
    vehicles: true,
    clientFormat: true,
    addSheet: true,
    sstFormat: true,
    payments: true,
    driverPayout: true,
    driverPaySlab: true,

    clientClaim: true,

    settings: true,
    users: true,
    fabMenu: true,
},

finance: {
    dashboard: true,
    clients: false,
    vehicles: false,
    clientFormat: true,
    addSheet: true,
    sstFormat: true,
    payments: true,
    driverPayout: true,
    driverPaySlab: true,

    clientClaim: true,

    settings:false,
    users:false,
    fabMenu:true,
},

auditor:{
 overlay:true,
 dashboard:true,
 clients:false,
 vehicles:false,
 clientFormat:true,
 addSheet:false,
 sstFormat:true,
 payments:false,
 driverPayout:false,
 driverPaySlab:false,

 clientClaim:false,

 settings:false,
 users:false,
 fabMenu:false,
}

};

export default permissions;